import React, { useState, useEffect } from "react";
import { db } from "../firebase/firebase";
import { collection, addDoc, doc, setDoc, getDocs } from "firebase/firestore";

const defaultTemplates = {
  koi: {
    name: "KOI",
    pricingMode: "koi",
    parkingPolicy: "actual",
    rules: {
      koiRates: {
        airportWithinBoundary: { standard: 78, executive: 98 },
        airportBeyondBoundary: { standard: 93, executive: 113 },
        abuDhabi: { standard: 248, executive: 268 }
      },
      koiBoundaryLatLng: []
    },
    driverPay: {
      mode: "minus8",
      minus8Value: 8
    }
  },
  cityGuide: {
    name: "City Guide",
    pricingMode: "cityGuide",
    parkingPolicy: "actual",
    driverPay: {
      mode: "minusParkingAllowance",
      parkingAllowance: 5
    }
  },
  manual: {
    name: "",
    pricingMode: "manual",
    parkingPolicy: "actual",
    driverPay: { mode: "manual" }
  }
};

export default function ClientPricingSetup() {
  const [clients, setClients] = useState([]);
  const [newClientName, setNewClientName] = useState("");
  const [template, setTemplate] = useState("manual");

  useEffect(() => {
    loadClients();
  }, []);

  async function loadClients() {
    const snap = await getDocs(collection(db, "clients"));
    setClients(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  }

  async function createClient() {
    if (!newClientName) return alert("Enter client name");

    const data = { ...defaultTemplates[template], name: newClientName.trim() };

    await setDoc(doc(db, "clients", newClientName.toLowerCase().replace(/ /g, "_")), data);

    setNewClientName("");
    loadClients();
    alert("Client profile created ✅");
  }

  return (
    <div style={{ padding: 20 }}>
      <h2>Client Pricing Management</h2>

      <div style={{ marginBottom: 20, border: "1px solid #ccc", padding: 10 }}>
        <h3>Add New Client</h3>

        <input
          type="text"
          placeholder="Client Name"
          value={newClientName}
          onChange={e => setNewClientName(e.target.value)}
          style={{ padding: 8, width: 250, marginRight: 10 }}
        />

        <select value={template} onChange={e => setTemplate(e.target.value)} style={{ padding: 8 }}>
          <option value="manual">Manual Pricing Client</option>
          <option value="koi">KOI (Airport → Business Bay boundary)</option>
          <option value="cityGuide">City Guide (Parking rule)</option>
        </select>

        <button onClick={createClient} style={{ marginLeft: 10, padding: "8px 15px" }}>
          ➕ Create Client
        </button>
      </div>

      <h3>Existing Clients</h3>
      <table border="1" cellPadding="8" style={{ width: "100%", background: "#fff" }}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Pricing Mode</th>
            <th>Parking</th>
            <th>Driver Mode</th>
          </tr>
        </thead>
        <tbody>
          {clients.map(c => (
            <tr key={c.id}>
              <td>{c.name}</td>
              <td>{c.pricingMode}</td>
              <td>{c.parkingPolicy}</td>
              <td>{c.driverPay?.mode}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
